<template>
  <div>
    <PageHeader :title="'جزئیات کمپین'" :items="pageHeaderItems" />
    <Loader v-if="loading" />
    <b-row>
      <b-col cols="12" md="12">
        <div class="card">
          <Section title="عنوان کمپین">
            <div class="my-3">
              <BaseText :maxlength="2000" :value="campaignModel.title" @input="campaignModel.title = $event" title="عنوان" placeholder="عنوان" />
            </div>
          </Section>
          <Section title="پیشنهاد دوره و بسته">
            <div class="my-3">
              <BaseText
                :maxlength="2000"
                :value="campaignModel.url"
                @input="campaignModel.url = $event"
                title="لینک دوره/بسته"
                placeholder="لینک دوره/بسته"
                required
                :showError="showUrlError"
                errortext="لطفا لینک دوره/بسته را وارد کنید"
              />
            </div>
            <span style="color: #00b19d"
              >لطفاً لینک مربوط به دوره یا بسته آموزشی موردنظر را وارد نمایید. توجه داشته باشید این لینک به‌عنوان پیشنهاد خرید برای کاربران از طریق پیامک ارسال خواهد شد و کد تخفیف
              روی آن فعال می‌گردد. بنابراین، در وارد کردن لینک صحیح، نهایت دقت را داشته باشید. <br /><br />
              <span style="color: #000">
                نمونه لینک صحیح: <br />
                https://dadbanan.com/package-details/135 <br />از وارد کردن هرگونه علامت یا متن اضافی بعد از آیدی خودداری فرمایید.
              </span>
            </span>
          </Section>
          <Section title="تنطیمات پیامک">
            <div class="my-3">
              <DateTimeOffset
                :value="campaignSendDate"
                @input="campaignSendDate = $event"
                title="تاریخ ارسال"
                placeholder="تاریخ ارسال"
                :hasDefaultDate="false"
                required
                :error="showSendDateError"
                errorText="لطفا تاریخ ارسال را وارد کنید"
              />
            </div>
            <div class="my-3">
              <DateTimeOffset
                :value="campaignSendTime"
                @input="campaignSendTime = $event"
                title="ساعت ارسال"
                placeholder="ساعت ارسال"
                :hasDefaultDate="false"
                type="time"
                required
                :error="showSendTimeError"
                errorText="لطفا ساعت ارسال را وارد کنید"
              />
            </div>
            <div class="my-3">
              <TextAreaInput :value="campaignModel.smsContent" @input="campaignModel.smsContent = $event" title="متن پیام" placeholder="متن پیام" />
            </div>
            <span
              >ادمین گرامی برای درج نام کاربر از <span style="color: #556ee6">Fname</span> ، برای نام خانوادگی از <span style="color: #556ee6">Lname</span> ، برای درج لینک دوره از
              <span style="color: #556ee6">Link</span> و کد تخفیف <span style="color: #556ee6">Dic</span> استفاده نمایید <br />
              برای نمونه : <br />
              <span style="color: #556ee6; font-weight: 600"
                >Fname Lname عزیز <br />
                پیشنهاد دوره لورم ایپورسم به شما <br />
                کد تخفیف شما : Dic <br />
                ثبت‌نام کنید : Link</span
              ></span
            >
          </Section>
          <div class="card p-3 d-flex flex-row justify-content-end">
            <b-button variant="primary ms-2 px-5" :disabled="$route.params.id" @click="addCampaign">ثبت</b-button>
          </div>
        </div>
        <div class="card">
          <Section title="اطلاعات دوره‌ و بسته منتخب">
            <List @update="fetchCampaign()" :class="!campaignModel.id || $route.path.includes('detail') ? 'disabled' : ''" />
          </Section>
        </div>
        <div class="card">
          <Section title="اطلاعات کد تخفیف">
            <div class="my-3">
              <BaseText :maxlength="2000" :value="campaignModel.discount.title" @input="campaignModel.discount.title = $event" title="نام کمپین" placeholder="نام کمپین" />
            </div>
            <div class="my-3">
              <BaseText
                required
                :disable="update"
                :showError="showError"
                :errortext="codeErrorText"
                :maxlength="2000"
                :value="campaignModel.discount.code"
                @input="campaignModel.discount.code = $event"
                title="کد تخفیف"
                placeholder="کد تخفیف"
              />
            </div>
            <div class="my-3">
              <DateTimeOffset
                range
                :error="showDateError"
                errorText="لطفا تاریخ را وارد کنید"
                :value="dateRange"
                @input="dateRange = $event"
                title="تاریخ"
                placeholder="تاریخ"
                :hasDefaultDate="false"
                :key="dateRender"
                required
              />
            </div>
            <div>
              <CountInput inputType="number" :value="campaignModel.discount.capacity" @input="campaignModel.discount.capacity = $event" title="ظرفیت" placeholder="ظرفیت" />
            </div>
            <div class="d-flex justify-content-between my-3">
              <div class="part">
                <div class="w-100">
                  <ComboBox
                    :searchedData="discountTypes"
                    title="نحوه اعمال تخفیف"
                    placeholder="نحوه اعمال تخفیف"
                    errortext="فیلد نحوه اعمال تخفیف الزامی است."
                    :selectedValue="selectedDiscountType"
                    @select="fillSelectedDiscountType"
                    required
                    :showError="showTypeError"
                    :inputStyle="comboStyle"
                  />
                </div>
              </div>
              <div class="w-50 ms-4">
                <BaseText
                  v-if="campaignModel.discount.type === 0"
                  inputType="number"
                  :maxlength="2000"
                  :value="campaignModel.discount.percent"
                  @input="campaignModel.discount.percent = $event"
                  title="میزان درصد"
                  placeholder="میزان درصد"
                />
                <BaseText v-else :maxlength="2000" :value="campaignModel.discount.amount" @input="campaignModel.discount.amount = $event" title="مبلغ" placeholder="مبلغ" />
              </div>
            </div>
            <div class="d-flex justify-content-between my-3">
              <div class="part">
                <div class="w-100">
                  <BaseText
                    :disable="selectedDiscountType === 'مبلغ تخفیف'"
                    :maxlength="2000"
                    :value="campaignModel.discount.upTo"
                    @input="campaignModel.discount.upTo = $event"
                    title="تا سقف (تومان)"
                    placeholder="تا سقف"
                  />
                </div>
              </div>
              <div class="w-50 ms-4 disabled">
                <BaseText
                  :maxlength="2000"
                  inputType="number"
                  :value="campaignModel.discount.userCapacity"
                  @input="campaignModel.discount.userCapacity = $event"
                  title="تعداد"
                  placeholder="تعداد"
                />
              </div>
            </div>
            <div class="d-flex">
              <b-form-checkbox v-model="campaignModel.discount.applyAfterGeneralDiscount" class="pt-2 me-3">
                <div class="mx-1">اعمال کد تخفیف بعد از تخفیف عمومی</div>
              </b-form-checkbox>
              <b-form-checkbox v-model="applyBeforGeneralDiscount" class="pt-2">
                <div class="mx-1">اعمال کد تخفیف قبل از تخفیف عمومی</div>
              </b-form-checkbox>
            </div>
            <div>
              <b-form-checkbox v-model="isDeactive" @change="setIsEnable" class="pt-2">
                <div class="mx-1">غیرفعال کردن کد تخفیف</div>
              </b-form-checkbox>
            </div>
          </Section>
          <div class="card p-3 d-flex flex-row justify-content-end">
            <b-button :disabled="campaignModel.discount.id || !campaignModel.campaignProducts.length" variant="primary ms-2 px-5" @click="addDiscount">ثبت</b-button>
          </div>
        </div>
      </b-col>
    </b-row>
    <div class="card p-3 d-flex flex-row justify-content-end">
      <b-button @click="$router.push('/list/campaigns')">انصراف</b-button>
      <b-button
        :disabled="!campaignModel.id || !campaignModel.campaignProducts.length || !campaignModel.discount.id || $route.path.includes('detail') || campaignModel.isActive"
        variant="success ms-2 px-5"
        @click="runCampaign"
        >اجرای کمپین</b-button
      >
    </div>

    <Toast :title="message" :error="error" :showToast="message !== ''" />
  </div>
</template>

<script>
import CountInput from '../../../components/common/form/CountInput.vue'
import BaseText from '../../../components/common/form/formModules/BaseText.vue'
import ComboBox from '../../../components/common/form/formModules/ComboBox.vue'
import DateTimeOffset from '../../../components/common/form/formModules/DateTimeOffset.vue'
import TextAreaInput from '../../../components/common/form/formModules/TextAreaInput.vue'
import Section from '../../../components/common/form/Section.vue'
import Toast from '../../../components/common/Toast.vue'
import PageHeader from '../../../components/layoutComponents/page-header.vue'
import Loader from '../../../components/widgets/loader.vue'
import dadbanCampaignProvider from '../../../services/dadban/campaign'
import moment from 'jalali-moment'
import List from '../../lists/list.vue'

export default {
  name: 'CampaignDetail',
  components: {
    PageHeader,
    BaseText,
    Toast,
    Loader,
    Section,
    TextAreaInput,
    List,
    CountInput,
    ComboBox,
    DateTimeOffset,
  },
  data() {
    return {
      campaignModel: {
        title: '',
        sendDate: '',
        sendTime: '',
        smsContent: '',
        url: '',
        discount: {
          title: '',
          code: '',
          startDate: '',
          endDate: '',
          isForCampaign: true,
          capacity: '',
          userCapacity: 1,
          upTo: '',
          percent: '',
          type: '',
          amount: '',
          isEnable: true,
          applyAfterGeneralDiscount: true,
        },
        campaignProducts: [],
      },
      message: '',
      error: false,
      loading: false,
      pageHeaderItems: [
        { text: 'داشبورد', href: '/' },
        { text: 'مدیریت کمپین‌ها', href: '/list/campaigns' },
        { text: 'جزئیات کمپین', active: true },
      ],
      showError: false,
      codeErrorText: '',
      showDateError: false,
      showTypeError: false,
      dateRender: true,
      update: false,

      discountTypes: [
        { key: 0, value: 'درصد تخفیف' },
        { key: 1, value: 'مبلغ تخفیف' },
      ],
      isDeactive: false,
      comboStyle: 'color: #495057',
      selectedDiscountType: '',
      dateRange: [],
      applyBeforGeneralDiscount: '',
      checkSpecifiedUser: true,
      discountDateRange: [],
      campaignSendDate: null,
      campaignSendTime: null,
      showUrlError: false,
      showSendDateError: false,
      showSendTimeError: false,
    }
  },
  watch: {
    applyBeforGeneralDiscount(c) {
      if (c) {
        this.campaignModel.discount.applyAfterGeneralDiscount = false
        return false
      }
      if (!c) {
        this.campaignModel.discount.applyAfterGeneralDiscount = true
      }
    },
    'campaignModel.discount.applyAfterGeneralDiscount'(c) {
      if (c) {
        this.applyBeforGeneralDiscount = false
        return false
      }
      if (!c) {
        this.applyBeforGeneralDiscount = true
      }
    },
    'campaignModel.discount.amount'(c) {
      if (c) {
        this.campaignModel.discount.amount = this.campaignModel.discount.amount.toString()
        this.campaignModel.discount.amount = c.replace(/\D/g, '').replace(/\B(?=(\d{3})+(?!\d))/g, ',')
      }
    },
    'campaignModel.discount.upTo'(c) {
      if (c) {
        this.campaignModel.discount.upTo = this.campaignModel.discount.upTo.toString()
        this.campaignModel.discount.upTo = c.replace(/\D/g, '').replace(/\B(?=(\d{3})+(?!\d))/g, ',')
      }
    },
    dateRange(c) {
      if (c.length > 1) {
        const start = c[0]
        const end = c[1]
        this.campaignModel.discount.startDate = start.replaceAll('/', '-') + 'T00:00:00.000Z'
        this.campaignModel.discount.endDate = end.replaceAll('/', '-') + 'T00:00:00.000Z'
      }

      if (c.length === 1) {
        this.campaignModel.discount.startDate = c[0].replaceAll('/', '-') + 'T00:00:00.000Z'
      }
      if (!c) {
        this.campaignModel.discount.startDate = null
        this.campaignModel.discount.endDate = null
      }
    },
    campaignSendDate(val) {
      if (val) {
        this.campaignModel.sendDate = val.replaceAll('/', '-') + 'T00:00:00.000Z'
      } else {
        this.campaignModel.sendDate = null
      }
    },
    campaignSendTime(val) {
      if (val) {
        this.campaignModel.sendTime = val
      } else {
        this.campaignModel.sendTime = null
      }
    },
  },
  mounted() {
    if (!this.$route.params.id) return
    this.fetchCampaign()

    setTimeout(() => {
      this.dateRender = false
    }, 3000)
  },
  methods: {
    async runCampaign() {
      this.loading = true
      const req = await dadbanCampaignProvider.runCampaign({
        id: this.$route.params.id,
      })
      if (req.status === 200) {
        if (req.data.data.id) {
          this.$router.push('/list/campaigns/detail/' + req.data.data.id)
          setTimeout(() => {
            this.message = 'کمپین با موفقیت اجرا شد'
          }, 2000)
          this.fetchCampaign()
        }
      }
      this.loading = false
    },
    async fetchCampaign() {
      try {
        const req = await dadbanCampaignProvider.getCampaign(this.$route.params.id)
        this.campaignModel = req.data.data.output
        this.isDeactive = !this.campaignModel.discount.isEnable
        this.campaignModel.discount.isForCampaign = true
        if (this.campaignModel.sendDate) {
          this.campaignSendDate = this.campaignModel.sendDate.replaceAll('-', '/')
        }

        if (this.campaignModel.sendTime) {
          this.campaignSendTime = this.campaignModel.sendTime
        }

        if (this.campaignModel.discount && this.campaignModel.discount.startDate) {
          this.discountDateRange = []
          this.discountDateRange.push(this.campaignModel.discount.startDate.slice(0, 10).replaceAll('-', '/'))

          if (this.campaignModel.discount.endDate) {
            this.discountDateRange.push(this.campaignModel.discount.endDate.slice(0, 10).replaceAll('-', '/'))
          }
        }
      } catch (error) {
        console.log(error)
      }
    },
    async addCampaign() {
      try {
        let hasError = false

        if (!this.campaignModel.url) {
          this.showUrlError = true
          hasError = true
          return
        } else {
          this.showUrlError = false
        }

        if (!this.campaignSendDate) {
          this.showSendDateError = true
          hasError = true
          return
        } else {
          this.showSendDateError = false
        }

        if (!this.campaignSendTime) {
          this.showSendTimeError = true
          hasError = true
        } else {
          this.showSendTimeError = false
        }

        if (hasError) {
          window.scrollTo(0, 0)
          return
        }

        const req = await dadbanCampaignProvider.addCampaign({
          title: this.campaignModel.title,
          sendDate: this.campaignModel.sendDate,
          sendTime: this.campaignModel.sendTime,
          smsContent: this.campaignModel.smsContent,
          url: this.campaignModel.url,
        })

        if (req.status === 200) {
          if (req.data.data.id) {
            this.campaignModel.id = req.data.data.id
            this.$route.params.id = req.data.data.id
            this.message = 'کمپین با موفقیت ثبت شد'
          } else {
            this.error = true
            this.message = 'خطایی رخ داده لطفا دوباره تلاش کنید.'
          }
          setTimeout(() => {
            this.message = ''
          }, 5000)
        }
      } catch (error) {
        console.log(error)
        this.error = true
        this.message = 'خطایی رخ داده لطفا دوباره سعی کنید'
      }
    },
    setIsEnable(e) {
      this.campaignModel.discount.isEnable = !e
      this.isDeactive = e
    },
    async addDiscount() {
      let userDiscount = []
      if (!this.dateRange.length) {
        this.showDateError = true
      } else this.showDateError = false
      if (!this.selectedDiscountType.length) {
        this.showTypeError = true
      } else this.showTypeError = false
      const notPersian = /^[A-Za-z][A-Za-z0-9]*$/.test(this.campaignModel.discount.code)
      if (!this.campaignModel.discount.code) {
        this.codeErrorText = 'لطفا کد تخفیف را وارد کنید'
        this.showError = true
      } else if (this.campaignModel.discount.code && !notPersian) {
        this.codeErrorText = 'لطفا فقط از کاراکترهای انگلیسی و اعداد استفاده کنید'
        this.showError = true
      } else this.showError = false

      if (this.showError || this.showDateError || this.showTypeError) {
        return false
      }

      this.campaignModel.discount.capacity = +this.campaignModel.discount.capacity
      this.campaignModel.discount.userCapacity = +this.campaignModel.discount.userCapacity
      if (this.campaignModel.discount.capacity === 0 || !this.campaignModel.discount.capacity) {
        this.campaignModel.discount.capacity = null
      }
      if (this.campaignModel.discount.userCapacity === 0 || !this.campaignModel.discount.userCapacity) {
        this.campaignModel.discount.userCapacity = null
      }
      if (this.campaignModel.discount.upTo === 0 || !this.campaignModel.discount.upTo) {
        this.campaignModel.discount.upTo = null
      }
      if (this.campaignModel.discount.percent === 0 || !this.campaignModel.discount.percent) {
        this.campaignModel.discount.percent = null
      }

      if (this.campaignModel.discount.type === 1) {
        this.campaignModel.discount.upTo = null
        this.campaignModel.discount.percent = null
      }
      if (this.campaignModel.discount.type === 0) {
        this.campaignModel.discount.amount = null
      }

      if (this.dateRange.length === 1) {
        this.campaignModel.discount.endDate = this.campaignModel.discount.startDate
      }
      if (this.campaignModel.discount.amount && typeof this.campaignModel.discount.amount === 'string') {
        this.campaignModel.discount.amount = this.campaignModel.discount.amount.replace(/[^a-zA-Z0-9 ]/g, '')
        this.campaignModel.discount.amount = +this.campaignModel.discount.amount
      }
      if (this.campaignModel.discount.upTo && typeof this.campaignModel.discount.upTo === 'string') {
        this.campaignModel.discount.upTo = this.campaignModel.discount.upTo.replace(/[^a-zA-Z0-9 ]/g, '')
        this.campaignModel.discount.upTo = +this.campaignModel.discount.upTo
      }

      try {
        const req = await dadbanCampaignProvider.addDiscount({
          discount: {
            ...this.campaignModel.discount,
            id: undefined,
          },
          campaignId: this.$route.params.id,
        })
        if (req.status === 200) {
          if (req.data.data.isSuccessful) {
            this.showError = false
            this.message = 'کد تخفیف با موفقیت ثبت شد'
            this.campaignModel.discount.id = req.data.data.id
          } else if (!req.data.data.isSuccessful) {
            this.codeErrorText = 'کد تخفیف تکراری است'
            this.showError = true
          } else {
            this.error = true
            this.message = 'خطایی رخ داده لطفا دوباره تلاش کنید.'
          }
          setTimeout(() => {
            this.message = ''
          }, 5000)
        }
      } catch (error) {
        this.error = true
        this.message = 'خطایی رخ داده لطفا دوباره سعی کنید'
      }
    },
    fillSelectedDiscountType(e) {
      console.log(e)
      this.selectedDiscountType = this.discountTypes.find((item) => item.value === e).value
      this.campaignModel.discount.type = this.discountTypes.find((item) => item.value === e).key
    },
    convertDate(date) {
      const formatDate = new Date(date).toLocaleDateString()
      const finalTime = moment(formatDate).locale('fa').format('YYYY/M/D')
      return finalTime
    },
  },
  computed: {
    isSubmitDisabled() {
      return !this.campaignModel.id || !this.campaignModel.campaignProducts || this.campaignModel.campaignProducts.length === 0
    },
  },
}
</script>

<style lang="scss" scoped>
.inner__style {
  background-color: white;
  padding: 23px;
}

.uploaded-photo {
  height: 122px;
  position: relative;
  img {
    width: 100%;
    height: 100%;
  }
}

.remove-icon {
  position: absolute;
  top: 5px;
  left: 5px;
  background-color: gray;
  border-radius: 50%;
  width: 20px;
  height: 20px;
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  i {
    color: white;
  }
}

.upload-text-size {
  font-size: 18px;
  text-align: center;
  margin-top: 10px;
  color: #495057;
}

.icon-size {
  font-size: 45px;
  text-align: center;
  display: block;
  color: #74788d;
}

.upload-photo-icon {
  height: 250px;
  width: 100%;
  border: 2px dashed #ced4da;
  border-radius: 8px;
  cursor: pointer;
}

.grand-parent {
  padding: 20px;
  border: 2px dashed #ced4da;
  justify-content: right;
  display: flex;
  align-items: right;
  position: relative;
}

.previewImage {
  border-radius: 4px;
}

.part {
  display: inline-flex;
  width: 50%;
}

.disabled {
  opacity: 0.5;
  pointer-events: none;
}
</style>
